import { Http } from '../../../support';
import ListItemHighlight from '../../../shared/support/ListItemHighlight';

const initialState = {
  busy: false,
  data: [],
  error: undefined,
  pagination: {
    limit: 25,
  },
  filters: {
    page: 1,
    search: '',
  },
};

const highlight = (store, data) => {
  const { data: prefacturas } = store.state.app.prefacturas.list;

  const tool = new ListItemHighlight(prefacturas);

  store.setState((state) => {
    state.app.prefacturas.list.data = tool.getNewList(data, true);
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.prefacturas.list.busy = true;
  });

  try {
    const params = {
      limit: meta.limit || store.state.app.prefacturas.list.pagination.limit,
      include: 'field',
      ...meta,
    };

    const response = await Http.get('api/prefacturas', { params });

    store.setState((state) => {
      state.app.prefacturas.list.busy = false;

      state.app.prefacturas.list.data = response.data;

      state.app.prefacturas.list.pagination = {
        ...state.app.prefacturas.list.pagination,
        ...response.meta.pagination,
        limit: params.limit || store.state.app.prefacturas.pagination.limit,
      };

      state.app.prefacturas.list.filters = {
        ...state.app.prefacturas.list.filters,
        ...meta,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.prefacturas.list.error = error.data || error;
      state.app.prefacturas.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.app.prefacturas.list.error = undefined;
};

const reset = (store) => (state) => {
  state.app.prefacturas.list = {
    ...initialState,
    pagination: {
      ...initialState.pagination,
    },
  };
};

const actions = {
  highlight,
  paginate,
  resetError,
  reset,
};

const PrefacturaListStore = {
  state: () => ({
    ...initialState,
    pagination: {
      ...initialState.pagination,
    },
  }),
  actions,
};

export default PrefacturaListStore;
